
export var i18Utils = (function () {
    const LINK_LOOKUP={
       
       "solar-energy":{
            "de":"konto",
       },
       "power-bi-weather":{
            "de":"power-bi-wetter",
       },
       "":{
            "de":"",
       },
       "/":{
            "de":"/",
       },
       "weather-data":{
            "de":"wetterdaten",
       },
       "weather-api":{
         "de":"wetter-api",
       },
       "weather-data-editions":{
         "de":"preisliste",
       },
       "agriculture-weather-data":{
         "de":"landwirtschaftliches-wetter",
       },
       "excel-weather":{
         "de":"excel-wetter",
       },
       "weather-data-editions":{
         "de":"microstrategy",
       },
       "about":{
         "de":"ueber-uns",
       },
       "usage":{
         "de":"nutzung",
       },
       "account":{
            "de":"konto",
       },
       "change-password":{
            "de":"passwort-aendern",
       },
       "sign-up":{
            "de":"melden-sie-sich-an",
       },
       "privacy":{
            "de":"privacy",
       },
    };

    return {
        redirectTo(link, language) {
           window.location=this.link(link, language);
        },
        link(link, language) {
           
            
            if (!language) {
                language = document.getElementsByTagName("html")[0].getAttribute("lang");
            }
            
            if (!language) {
                console.error( `No language for link ${link}`);
                if (link === "/" || link ==="") {
                  return "/";
                } else {
                  return "/"+link+"/";
                }
            }
           
            let langParts = language.split('-');
            language=langParts[0];

            if (link === "/" || link ==="") {
              if (language!=='en' && language) {
                return "/"+language+"/";
              }
              return "/";
            }

            if (!LINK_LOOKUP[link]) {
                console.error( `No look up for link ${link}`);
                return "/"+link+"/";
            }
            if (LINK_LOOKUP[link][language]) {
                link=language+"/"+LINK_LOOKUP[link][language];
            } else if (language!=='en') {
                console.error( `No language lookup for link ${link}, ${language}`);
                return "/"+link+"/";
            }
            if (link==="/") return "/";
            return "/"+link+"/";
        },
    }

}());
